import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    VALIDATED_VISIBILITY_ASSETS_GET_FAILURE:
        "VALIDATED_VISIBILITY_ASSETS_GET_FAILURE",
    VALIDATED_VISIBILITY_ASSETS_GET_REQUEST:
        "VALIDATED_VISIBILITY_ASSETS_GET_REQUEST",
    VALIDATED_VISIBILITY_ASSETS_GET_SUCCESS:
        "VALIDATED_VISIBILITY_ASSETS_GET_SUCCESS",

    VALIDATED_VISIBILITY_ASSETS_ITEM_SET:
        "VALIDATED_VISIBILITY_ASSETS_ITEM_SET",
    VALIDATED_VISIBILITY_ASSETS_ITEM_CLEAR:
        "VALIDATED_VISIBILITY_ASSETS_ITEM_CLEAR"
};

export const actionCreators = {
    getRequest: (auditAssetId) => ({
        type: actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_REQUEST,
        payload: { auditAssetId },
        [WAIT_FOR_ACTION]: actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_FAILURE
    }),
    getSuccess: (assetAuditor: Array<any>) => ({
        type: actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_SUCCESS,
        payload: { assetAuditor }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.VALIDATED_VISIBILITY_ASSETS_GET_FAILURE,
        error
    }),

    itemClear: () => ({
        type: actionTypes.VALIDATED_VISIBILITY_ASSETS_ITEM_CLEAR
    }),
    itemSet: (audit: any) => ({
        type: actionTypes.VALIDATED_VISIBILITY_ASSETS_ITEM_SET,
        payload: { audit }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};